<template>
  <cytomine-modal :active="active" :title="$t('rename-item')" @close="close">
    <div class="modal-form-content">
      <div class="form-section">
        <label class="form-label">{{ $t('new-name') }}</label>
        <b-input 
          v-model="newName" 
          :placeholder="$t('enter-new-name')"
          required
          ref="nameInput"
          @keyup.enter="renameItem"
        ></b-input>
        <p class="help-text">{{ $t('rename-item-help') }}</p>
      </div>
    </div>

    <template #footer>
      <button class="button is-outlined" type="button" @click="close">{{ $t('button-cancel') }}</button>
      <button 
        class="button is-primary" 
        @click="renameItem" 
        :disabled="!newName.trim() || newName === itemName"
        :loading="isRenaming"
      >
        {{ $t('button-rename') }}
      </button>
    </template>
  </cytomine-modal>
</template>

<script>
import CytomineModal from '../utils/CytomineModal.vue';

export default {
  name: 'RenameModal',
  components: {
    CytomineModal
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    itemName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      newName: '',
      isRenaming: false
    };
  },
  watch: {
    active(val) {
      if (val) {
        this.newName = this.itemName;
        this.isRenaming = false;
        this.$nextTick(() => {
          if (this.$refs.nameInput) {
            // Focus the input
            this.$refs.nameInput.focus();
            // Select all text in the input by accessing the underlying DOM element
            const inputElement = this.$refs.nameInput.$el.querySelector('input');
            if (inputElement) {
              inputElement.select();
            }
          }
        });
      }
    }
  },
  methods: {
    renameItem() {
      if (!this.newName.trim() || this.newName === this.itemName) return;
      
      this.isRenaming = true;
      this.$emit('rename', this.newName.trim());
      this.$emit('update:active', false);
    },
    close() {
      this.$emit('update:active', false);
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/dark-variables.scss';

.modal-form-content {
  padding: 0.35rem 0.15rem 0.15rem;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.form-label {
  color: $dark-text-primary;
  font-size: 0.86rem;
  font-weight: 700;
}

.help-text {
  color: $dark-text-disabled;
  font-size: 0.78rem;
  line-height: 1.4;
  margin-top: 0.2rem;
}
</style>
